__webpack_require__.p = "https://cdn.craft.cloud/0cdda362-02be-4fae-8df2-8857e19bee99/builds/a1b96afd-f30a-4187-8104-7bdb16d9eed4/artifacts/";